import { Controller as BaseController } from "stimulus";
import './index.scss';

export class Controller extends BaseController {
  connect() {}
}
